import React from "react";
import PropTypes from "prop-types";
// react plugin for creating charts
// @material-ui/core
import withStyles from "@material-ui/core/styles/withStyles";
import DateRange from "@material-ui/icons/DateRange";
import CircularProgress from '@material-ui/core/CircularProgress';

import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardFooter from "components/Card/CardFooter.jsx";

import dashboardStyle from "assets/jss/material-dashboard-react/views/dashboardStyle.jsx";
import SimpleSvgIcon from "components/Card/SimpleSvgIcon.jsx";
import homeSvgDef from "assets/img/home_water.svg";

import { firestore } from "initfb.js";
import NumSpan from "components/NumSpan.jsx";

class WaterCard extends React.Component {
	state = {
		lastConsumption: null,
		lastDate: null,
		sentConsumption: null,
		sentDate: null,
	};

	async componentDidMount() {
		const self = this;
		firestore.collection('states').orderBy('date', 'desc').limit(1).get().then(async function (data) {
			if (data.docs && data.docs[0] && data.docs[0].ref) {
				var item = (await data.docs[0].ref.get()).data();
				self.setState({
					lastConsumption: item.state,
					lastDate: item.date.toDate()
				});
			}
		});
		firestore.collection('states').where("sentDay", "==", true).orderBy('date', 'desc').limit(1).get().then(async function (data) {
			if (data.docs && data.docs[0] && data.docs[0].ref) {
				var item = (await data.docs[0].ref.get()).data();
		 		self.setState({
		 			sentConsumption: item.state,
		 			sentDate: item.date.toDate()
		 		});
		 	}
		});
	}

	render() {
		const { classes } = this.props;
		var days = 0;
		var loading = true;
		if (this.state.lastConsumption != null && this.state.sentConsumption != null) {
			var timeDiff = Math.abs(this.state.lastDate.getTime() - this.state.sentDate.getTime());
			days = Math.ceil(timeDiff / (1000 * 3600 * 24)); 
			loading = false;
		}
		
		return (
			<Card>
				<CardHeader color="info" stats icon>
					<CardIcon color="info">
						<SimpleSvgIcon svgFile={homeSvgDef} />
					</CardIcon>
					<p className={classes.cardCategory}>Voda</p>
					<h3 className={classes.cardTitle}>
						{loading ? (<span>Zjišťuji...</span>) : (<span><NumSpan value={this.state.lastConsumption - this.state.sentConsumption} precision={1} /> <small>m<sup>3</sup></small></span>)  }
					</h3>
				</CardHeader>
				<CardFooter stats>
					<div className={classes.stats}>
						{loading ? <CircularProgress size={22} style={{margin:'0 3px 0 3px', color: '#999999'}}/> : <DateRange />}
						{loading ? null : <span>{days} dní</span>}
					</div>
				</CardFooter>
			</Card>
		)
	}
}

WaterCard.propTypes = {
	classes: PropTypes.object.isRequired
};
  
export default withStyles(dashboardStyle)(WaterCard);
  



// WEBPACK FOOTER //
// ./src/components/Card/WaterCard.jsx